<!--
 * @Author: Yu Weifeng weifeng.yu@gientech.com
 * @LastEditors: Yu Weifeng weifeng.yu@gientech.com
 * @Description: 仪表盘
-->
<script>
import ChartBase from '../base.vue';
/******* echarts *********/
import * as echarts from 'echarts/core';
import { GaugeChart } from 'echarts/charts';
import { DatasetComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { isEmpty } from 'lodash';
echarts.use([DatasetComponent, GaugeChart, CanvasRenderer]);

export default {
  name: 'LcChartInstrumentPanel',
  mixins: [ChartBase],
  props: {},
  data() {
    return {
      chartClass: ['lc-chart__instrumentpanel']
    };
  },
  created() {
    // preset
  },
  mounted() {},
  methods: {
    getCurrentEcharts() {
      return echarts;
    },
    processChartData(data) {
      const options = this.mapOptions;
      if (!isEmpty(options)) {
        data.forEach(item => {
          item['name'] = item[options?.dimension];
          item['value'] = item[options?.valueMap];
        });
      }

      this.chartData = data;
    },
    processOptions(options) {
      if (Array.isArray(options['series'])) {
        options['series'][0]['data'] = this.chartData;
      } else {
        options['series']['data'] = this.chartData;
      }
      this.chartOptions = options;
    }
  }
};
</script>
